import { NAMESPACE_MATCH_OF_THE_DAY } from 'app/constants/Context';
import createSelectors, { GridSubheaderBreadcrumbs } from 'app/redux/betting-presentation/grid/selectors';

import * as entityGridSelectors from './entities';

// ---

export type Breadcrumbs = GridSubheaderBreadcrumbs;

export const {
  mainLineId,
  stakeLayout,
  gridSubheaderBreadcrumbSelector,
} = createSelectors(NAMESPACE_MATCH_OF_THE_DAY, entityGridSelectors, { path: ['grid'] });
